// // // import React, { useState, useEffect, useContext } from "react";
// // // import { getAllUnits } from "../../../actions/unitActions";
// // // import { ItemContext } from "../../../Context/ItemContext";
// // // import { useDispatch, useSelector } from "react-redux";
// // // import { useLocation, useHistory } from "react-router-dom";
// // // import usePermissions from "../../../utils/permissions";
// // // import {
// // //   Radio,
// // //   RadioGroup,
// // //   FormControlLabel,
// // //   Container,
// // //   Box,
// // //   Button,
// // //   IconButton,
// // // } from "@material-ui/core";
// // // import NoData from "../../svgIcons/NoData";
// // // import Spinner from "../../Spinner/Spinner";
// // // import Units from "./Units";
// // // import AddUnit from "./addUnit.js";
// // // import AddIcon from "@material-ui/icons/Add";
// // // import { makeStyles } from "@material-ui/core/styles";

// // // const useStyles = makeStyles((theme) => ({
// // //   root: {
// // //     padding: theme.spacing(2),
// // //     display: "flex",
// // //     flexDirection: "column",
// // //     alignItems: "center",
// // //   },
// // // }));

// // // const UnitsList = () => {
// // //   const classes = useStyles();
// // //   const history = useHistory();
// // //   const location = useLocation();
// // //   const [open, setOpen] = useState(false);
// // //   // const [unitId, setUnitId] = useState(null)
// // //   const { unitId, setUnitId } = useContext(ItemContext);
// // //   const dispatch = useDispatch();
// // //   const user = JSON.parse(localStorage.getItem("profile"));
// // //   const units = useSelector((state) => state.units.units);
// // //   const {
// // //     loading: permissionsLoading,
// // //     canUpdatePage,
// // //     canDeletePage,
// // //     canCreatePage,
// // //     isAdmin,
// // //   } = usePermissions();

// // //   const isLoading = useSelector((state) => state.units.isLoading); // Assuming you have stored items in the Redux store

// // //   useEffect(() => {
// // //     dispatch(getAllUnits());
// // //     // dispatch(getItemsByUser({ search: user.result?._id || user.result.googleId }));
// // //   }, [location, dispatch]);

// // //   if (!user) {
// // //     history.push("/login");
// // //   }

// // //   if (isLoading) {
// // //     return (
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           alignItems: "center",
// // //           justifyContent: "center",
// // //           flexDirection: "column",
// // //           paddingTop: "20px",
// // //         }}
// // //       >
// // //         <Spinner />
// // //       </div>
// // //     );
// // //   }

// // //   if (units.length === 0) {
// // //     return (
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           alignItems: "center",
// // //           justifyContent: "center",
// // //           flexDirection: "column",
// // //           paddingTop: "20px",
// // //           margin: "80px",
// // //         }}
// // //       >
// // //         <NoData />
// // //         <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
// // //           No items yet. Click the plus icon to add items
// // //         </p>
// // //       </div>
// // //     );
// // //   }
// // //   return (
// // //     <Container maxWidth="md" className={classes.root}>
// // //       {/* <Button
// // //         variant="contained"
// // //         color="primary"
// // //         onClick={() => {
// // //           setUnitId(null);
// // //           setOpen(true);
// // //         }}
// // //        // className={classes.addCategoryButton}
// // //         startIcon={<AddIcon />}
// // //       >
// // //         Add Unit
// // //       </Button> */}
// // //       <Button
// // //         variant="contained"
// // //         color="primary"
// // //         onClick={() => {
// // //           setUnitId(null);
// // //           setOpen(true);
// // //         }}
// // //         startIcon={<AddIcon />}
// // //         disabled={
// // //           permissionsLoading || (!isAdmin() && !canCreatePage("Units"))
// // //         }
// // //         style={{
// // //           cursor:
// // //             permissionsLoading || (!isAdmin() && !canCreatePage("Units"))
// // //               ? "not-allowed"
// // //               : "pointer",
// // //         }}
// // //       >
// // //         Add Unit
// // //       </Button>

// // //       <AddUnit
// // //         open={open}
// // //         setOpen={setOpen}
// // //         unitId={unitId}
// // //         setUnitId={setUnitId}
// // //         units={units}
// // //       />
// // //       <Units
// // //         open={open}
// // //         setOpen={setOpen}
// // //         unitId={unitId}
// // //         setUnitId={setUnitId}
// // //         units={units}
// // //       />
// // //     </Container>
// // //   );
// // // };

// // // export default UnitsList;

// // import React, { useState, useEffect } from "react";
// // import { getAllUnits } from "../../../actions/unitActions";
// // import { useDispatch, useSelector } from "react-redux";
// // import { useLocation, useHistory } from "react-router-dom";
// // import usePermissions from "../../../utils/permissions";
// // import { Container, Button, Tabs, Tab, Box } from "@material-ui/core";
// // import AddIcon from "@material-ui/icons/Add";
// // import { makeStyles } from "@material-ui/core/styles";
// // import AddBasicUnit from "./AddBasicUnit";
// // import MapUnit from "./MapUnit";
// // import Units from "./Units";
// // import MappedUnits from "./MappedUnits";
// // import NoData from "../../svgIcons/NoData";
// // import Spinner from "../../Spinner/Spinner";

// // const useStyles = makeStyles((theme) => ({
// //   root: { padding: theme.spacing(2) },
// //   tabPanel: { marginTop: theme.spacing(2) },
// // }));

// // function TabPanel(props) {
// //   const { children, value, index, ...other } = props;
// //   return (
// //     <div role="tabpanel" hidden={value !== index} {...other}>
// //       {value === index && <Box p={3}>{children}</Box>}
// //     </div>
// //   );
// // }

// // const UnitsList = () => {
// //   const classes = useStyles();
// //   const history = useHistory();
// //   const location = useLocation();
// //   const [openAdd, setOpenAdd] = useState(false);
// //   const [openMap, setOpenMap] = useState(false);
// //   // const [tabValue, setTabValue] = useState(0);
// //   const [editUnit, setEditUnit] = useState(null); // Define setEditUnit here
// //   const dispatch = useDispatch();
// //   const user = JSON.parse(localStorage.getItem("profile"));
// //   const units = useSelector((state) => state.units.units);
// //   const { loading: permissionsLoading, canCreatePage, isAdmin } = usePermissions();
// //   const isLoading = useSelector((state) => state.units.isLoading);
// //   const [tabValue, setTabValue] = useState(() => {
// //     const params = new URLSearchParams(location.search);
// //     const tab = parseInt(params.get("tab"), 10);
// //     return isNaN(tab) ? 0 : tab; // Default to 0 if no valid tab param
// //   });
  

// //   useEffect(() => {
// //     dispatch(getAllUnits());
// //   }, [location, dispatch]);

// //   // const handleTabChange = (event, newValue) => {
// //   //   setTabValue(newValue);
// //   // };

// //   const handleTabChange = (event, newValue) => {
// //     setTabValue(newValue);
// //     const params = new URLSearchParams(location.search);
// //     params.set("tab", newValue);
// //     history.replace({ ...location, search: params.toString() }); // Update URL without full navigation
// //   };

// //   if (!user) history.push("/login");

// //   if (isLoading) {
// //     return (
// //       <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px" }}>
// //         <Spinner />
// //       </div>
// //     );
// //   }

// //   if (units.length === 0) {
// //     return (
// //       <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px", margin: "80px" }}>
// //         <NoData />
// //         <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>No units yet. Click the plus icon to add units.</p>
// //       </div>
// //     );
// //   }

// //   return (
// //     <Container maxWidth="lg" className={classes.root}>
// //       <Tabs value={tabValue} onChange={handleTabChange} aria-label="unit tabs">
// //         <Tab label="Units" />
// //         <Tab label="Mapped Units" />
// //       </Tabs>

// //       <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
// //         <Button
// //           variant="contained"
// //           color="primary"
// //           onClick={() => setOpenAdd(true)}
// //           startIcon={<AddIcon />}
// //           disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
// //           style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
// //         >
// //           Add Unit
// //         </Button>
// //         <AddBasicUnit open={openAdd} setOpen={setOpenAdd} />
// //         <Units units={units} />
// //       </TabPanel>

// //       <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
// //         <Button
// //           variant="contained"
// //           color="primary"
// //           onClick={() => { setEditUnit(null); setOpenMap(true); }}
// //           startIcon={<AddIcon />}
// //           disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
// //           style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
// //         >
// //           Map Unit
// //         </Button>
// //         <MapUnit open={openMap} setOpen={setOpenMap} units={units} editUnit={editUnit} />
// //         <MappedUnits units={units} setOpenMap={setOpenMap} setEditUnit={setEditUnit} /> {/* Pass setEditUnit */}
// //       </TabPanel>
// //     </Container>
// //   );
// // };

// // export default UnitsList;


// import React, { useState, useEffect } from "react";
// import { getAllUnits, getUnitMappings } from "../../../actions/unitActions";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useHistory } from "react-router-dom";
// import usePermissions from "../../../utils/permissions";
// import { Container, Button, Tabs, Tab, Box } from "@material-ui/core";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles } from "@material-ui/core/styles";
// import AddBasicUnit from "./AddBasicUnit";
// import MapUnit from "./MapUnit";
// import Units from "./Units";
// import MappedUnits from "./MappedUnits";
// import NoData from "../../svgIcons/NoData";
// import Spinner from "../../Spinner/Spinner";

// const useStyles = makeStyles((theme) => ({
//   root: { padding: theme.spacing(2) },
//   tabPanel: { marginTop: theme.spacing(2) },
// }));

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div role="tabpanel" hidden={value !== index} {...other}>
//       {value === index && <Box p={3}>{children}</Box>}
//     </div>
//   );
// }

// const UnitsList = () => {
//   const classes = useStyles();
//   const history = useHistory();
//   const location = useLocation();
//   const [openAdd, setOpenAdd] = useState(false);
//   const [openMap, setOpenMap] = useState(false);
//   const [editMapping, setEditMapping] = useState(null);
//   const dispatch = useDispatch();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const units = useSelector((state) => state.units.units);
//   const mappings = useSelector((state) => state.units.mappings || []);
//   const { loading: permissionsLoading, canCreatePage, isAdmin } = usePermissions();
//   const isLoading = useSelector((state) => state.units.isLoading);
//   const [tabValue, setTabValue] = useState(() => {
//     const params = new URLSearchParams(location.search);
//     const tab = parseInt(params.get("tab"), 10);
//     return isNaN(tab) ? 0 : tab;
//   });

//   useEffect(() => {
//     dispatch(getAllUnits());
//     dispatch(getUnitMappings());
//   }, [location, dispatch]);

//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//     const params = new URLSearchParams(location.search);
//     params.set("tab", newValue);
//     history.replace({ ...location, search: params.toString() });
//   };

//   if (!user) history.push("/login");

//   if (isLoading) {
//     return (
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px" }}>
//         <Spinner />
//       </div>
//     );
//   }

//   if (units.length === 0) {
//     return (
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px", margin: "80px" }}>
//         <NoData />
//         <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>No units yet. Click the plus icon to add units.</p>
//       </div>
//     );
//   }

//   return (
//     <Container maxWidth="lg" className={classes.root}>
//       <Tabs value={tabValue} onChange={handleTabChange} aria-label="unit tabs">
//         <Tab label="Units" />
//         <Tab label="Mapped Units" />
//       </Tabs>

//       <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => setOpenAdd(true)}
//           startIcon={<AddIcon />}
//           disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
//           style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
//         >
//           Add Unit
//         </Button>
//         <AddBasicUnit open={openAdd} setOpen={setOpenAdd} />
//         <Units units={units} />
//       </TabPanel>

//       <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => { setEditMapping(null); setOpenMap(true); }}
//           startIcon={<AddIcon />}
//           disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
//           style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
//         >
//           Map Unit
//         </Button>
//         <MapUnit open={openMap} setOpen={setOpenMap} units={units} editMapping={editMapping} />
//         <MappedUnits mappings={mappings} setOpenMap={setOpenMap} setEditMapping={setEditMapping} />
//       </TabPanel>
//     </Container>
//   );
// };

// export default UnitsList;

import React, { useState, useEffect } from "react";
import { getAllUnits, getUnitMappings } from "../../../actions/unitActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import usePermissions from "../../../utils/permissions";
import { Container, Button, Tabs, Tab, Box } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import AddBasicUnit from "./AddBasicUnit";
import MapUnit from "./MapUnit";
import Units from "./Units";
import MappedUnits from "./MappedUnits";
import NoData from "../../svgIcons/NoData";
import Spinner from "../../Spinner/Spinner";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  tabPanel: { marginTop: theme.spacing(2) },


}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box p={3} marginLeft={10} >{children}</Box>}
    </div>
  );
}

const UnitsList = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [openAdd, setOpenAdd] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [editMapping, setEditMapping] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { units, isLoading } = useSelector((state) => state.units || { units: [], isLoading: false });
  const mappings = useSelector((state) => state.units.mappings || []);
  const { loading: permissionsLoading, canCreatePage, isAdmin } = usePermissions();
  const [tabValue, setTabValue] = useState(() => {
    const params = new URLSearchParams(location.search);
    const tab = parseInt(params.get("tab"), 10);
    return isNaN(tab) ? 0 : tab;
  });

  useEffect(() => {
    console.log('Dispatching getAllUnits and getUnitMappings');
    dispatch(getAllUnits()); // Ensure these are functions
    dispatch(getUnitMappings());
  }, [location, dispatch]);

  useEffect(() => {
    console.log('Redux State - Units:', JSON.stringify(units, null, 2));
    console.log('Redux State - Mappings:', JSON.stringify(mappings, null, 2));
  }, [units, mappings]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    const params = new URLSearchParams(location.search);
    params.set("tab", newValue);
    history.replace({ ...location, search: params.toString() });
  };

  if (!user) {
    history.push("/login");
    return null;
  }

  if (isLoading) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px" }}>
        <Spinner />
      </div>
    );
  }

  // if (units.length === 0) {
  //   return (
  //     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "20px", margin: "80px" }}>
  //       <NoData />
  //       <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>No units yet. Click the plus icon to add units.</p>
  //     </div>
  //   );
  // }

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Tabs value={tabValue} onChange={handleTabChange} aria-label="unit tabs">
        <Tab label="Units" />
        <Tab label="Mapped Units" />
      </Tabs>

      <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenAdd(true)}
          startIcon={<AddIcon />}
          disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
          style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
        >
          Add Unit
        </Button>
        <AddBasicUnit open={openAdd} setOpen={setOpenAdd} />
        <Units units={units} />
      </TabPanel>

      <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => { setEditMapping(null); setOpenMap(true); }}
          startIcon={<AddIcon />}
          disabled={permissionsLoading || (!isAdmin() && !canCreatePage("Units"))}
          style={{ marginBottom: 16, cursor: permissionsLoading || (!isAdmin() && !canCreatePage("Units")) ? "not-allowed" : "pointer" }}
        >
          Map Unit
        </Button>
        <MapUnit open={openMap} setOpen={setOpenMap} units={units} editMapping={editMapping} />
        <MappedUnits mappings={mappings} setOpenMap={setOpenMap} setEditMapping={setEditMapping} />
      </TabPanel>
    </Container>
  );
};

export default UnitsList;